import styled from "styled-components";
import theme from "../../style/theme";
import {ImageData} from "../../utils/image/image-data";
import CloseSmallLineIcon from "../icons/CloseSmallLineIcon/CloseSmallLineIcon";

interface Props {
    dialogImageData: ImageData;
    index: number;
    isDragging: boolean;
    isSelected: boolean;
    handleClickRemoveButton: (url: string) => void;
}

export const DraggableSmallLocationImagePreviewCard: React.FC<Props> = (
    {
        dialogImageData,
        index,
        isDragging,
        isSelected,
        handleClickRemoveButton,
    }
) => {
    let border = `1px solid ${theme.palette.primitives.gray400}`;
    if (isSelected) {
        border = `2px solid ${theme.palette.primitives.black}`;
    }
    if (isDragging) {
        border = `2px solid ${theme.palette.primitives.yellow400}`;
    }

    return (
        <DraggableSmallLocationImagePreviewCardContainer>
            <ImageContainer imageUrl={dialogImageData.url} border={border}>
                <DeleteImageContainer
                    onClick={() => handleClickRemoveButton(dialogImageData.url)}
                >
                    <CloseSmallLineIcon
                        width="1.5rem"
                        height="1.5rem"
                        fill={theme.palette.primitives.gray400}
                    />
                </DeleteImageContainer>{" "}
            </ImageContainer>
            <IndexContainer index={index}>
                <IndexContent>{index + 1}</IndexContent>
            </IndexContainer>
        </DraggableSmallLocationImagePreviewCardContainer>
    );
};

const DraggableSmallLocationImagePreviewCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 10.625rem;
  height: 9.625rem;
  margin-right: 0.75rem;
`;

interface ImageContainerProps {
    imageUrl: string;
    border: string;
}

const ImageContainer = styled.div<ImageContainerProps>`
  position: relative;
  height: 7.063rem;
  border-radius: 0.25rem;
  background: url(${(props) => props.imageUrl}) no-repeat center;
  background-size: cover;
  border: ${(props) => props.border};
`;

const DeleteImageContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.palette.primitives.white};
  border-radius: 50%;
  bottom: 0.5rem;
  right: 0.5rem;
`;

interface IndexContainerProps {
    index: number;
}

const IndexContainer = styled.div<IndexContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.563rem;
`;

const IndexContent = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray400};
`;
